// do not manually modify this auto-generated file!!
import { FeatureFlagType } from './feature-flags.types';

export type AvailableFeatureFlags =
  | 'applet-prototype'
  | 'dynamicFlag'
  | 'environments-and-web-applets'
  | 'environments-ui'
  | 'fifthFlag'
  | 'first-demo-feature-flag'
  | 'manager-navigation-visibility'
  | 'managerProjectIdForContactCenter'
  | 'platform-integrations'
  | 'second-demo-feature-flag'
  | 'thirdFlagWithCamelCase'
  | 'wipChildOrgs'
  | 'wipTeams'
  | 'wipUsers';

export const DefaultFeatureFlags: FeatureFlagType = {
  'applet-prototype': 'true',
  dynamicFlag: 'false',
  'environments-and-web-applets': 'true',
  'environments-ui': 'true',
  fifthFlag: 'false',
  'first-demo-feature-flag': 'true',
  'manager-navigation-visibility': 'false',
  managerProjectIdForContactCenter: 'false',
  'platform-integrations': 'true',
  'second-demo-feature-flag': 'false',
  thirdFlagWithCamelCase: 'false',
  wipChildOrgs: 'true',
  wipTeams: 'true',
  wipUsers: 'true',
};
